import { EventEmitter, OnInit } from '@angular/core';
import { Output } from '@angular/core';
import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-details',
  standalone: true,
  imports: [],
  templateUrl: './edit-details.component.html',
  styleUrl: './edit-details.component.css'
})
export class EditDetailsComponent implements OnInit {
  @Output() SaveDetailsEmitter: EventEmitter<string> = new EventEmitter();
  @Output() CloseEventEmitter: EventEmitter<string> = new EventEmitter();
  public CurrentDetails: string;


  public constructor() {
    this.CurrentDetails = "";
  }

  public ngOnInit() {

  }

  UpdateValue(ev: any) {
    this.CurrentDetails = ev.target.value;
  }

  SaveDetail() {
    this.SaveDetailsEmitter.emit(this.CurrentDetails);
  }

  CloseWindow() {
    this.CloseEventEmitter.emit("");
  }
}
